import React, { useState, useRef } from "react";
import { Redirect, useHistory, useLocation } from 'react-router-dom';

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Container, Card, Col, Row, Button, Form, Image} from 'react-bootstrap'
import BackgroundSlider from 'react-background-slider'
import queryString from 'query-string'

import {AiOutlineEye, AiOutlineEyeInvisible} from 'react-icons/ai'
import { clearMessage } from "../actions/message-action";

import { resetPassword } from "../actions/auth-action";

import img1 from '../images/bridg/login-bg-1.jpg'
import img2 from '../images/bridg/login-bg-2.jpg'
import img3 from '../images/bridg/login-bg-3.jpg'

import sg3 from "../images/sg3plus.png"
import AuthVerify from "../components/AuthVerify";
import { MessageBar, MessageBarType } from "@fluentui/react";

const ResetPassword = (props) => {
  
  const { t } = useTranslation();

  const history = useHistory();

  const { search } = useLocation();
  const values = queryString.parse(search)
  const token = values.token;
  const urlUsername = values.username || "";
  const urlDomain = values.domain || "";
  
  const form = useRef();
  const checkBtn = useRef();
  
  const txtRefPassword = useRef()
  const txtRefPasswordConfirm = useRef();
  
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const [isInvalidPassword, setIsInvalidPassword] = useState(false);
  const [isInvalidPasswordConfirmation, setIsInvalidPasswordConfirmation] = useState(false);

  const [passwordMessageError, setPasswordMessageError] = useState("");
  const [passwordConfirmationMessageError, setPasswordConfirmationMessageError] = useState("");

  const [loading, setLoading] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const { isLoggedIn } = useSelector(state => state.auth);
  const { _message } = useSelector(state => state.message);
  const [message, setMessage] = useState(_message);
  
  const { user: currentAuth } = useSelector((state) => state.auth);

  
  const dispatch = useDispatch();


  const isValidPassword = (password, passwordConfirmation) => {
    let passwordShemaValid = true;
    let passwordConfirmationShemaValid = true;
    let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)(?=.{10,}$)/
    
    if (password !== "") {
      if (regex.test(password) === false) {
        passwordShemaValid = false;
        setPasswordMessageError(t('data-lang-msg-invalid-password'));
        setIsInvalidPassword(true);
      }
    }
    else {
      passwordShemaValid = false;
        setPasswordMessageError(t('data-lang-msg-required-field'));
        setIsInvalidPassword(true);
    }

    if (passwordConfirmation !== "") {
      if (regex.test(passwordConfirmation) === false) {
          passwordConfirmationShemaValid = false;
          setPasswordConfirmationMessageError(t('data-lang-msg-invalid-password'));
          setIsInvalidPasswordConfirmation(true);
      }
    }
    else {
        passwordConfirmationShemaValid = false;
        setPasswordConfirmationMessageError(t('data-lang-msg-required-field'));
        setIsInvalidPasswordConfirmation(true);
    }

    if (passwordConfirmationShemaValid && passwordShemaValid) {
      if (password !== passwordConfirmation) {
        setPasswordMessageError('');
        setPasswordConfirmationMessageError(t('data-lang-msg-notsame-passwordandconfirmation'));
        setIsInvalidPassword(false);
        setIsInvalidPasswordConfirmation(true);
      return (true)
      }
      else {
        return (false)
      }
    }
    else {
      return (true)
    }
  }

  const onChangePassword = (e) => {
    const password = e.target.value;
    setIsInvalidPassword(password === "");
    setPassword(password);
  };
  
  const onChangePasswordConfirmation = (e) => {
    const passwordConfirmation = e.target.value;
    setIsInvalidPasswordConfirmation(passwordConfirmation === "");
    setPasswordConfirmation(passwordConfirmation);
  };

  const handleGoLogin = (e) => {
    dispatch(clearMessage());
    history.push('/login')
  }

  const handleResetPassword = (e) => {
    e.preventDefault();
    
    setSuccessful(false);
    setLoading(true);
    setMessage("");

    let _isInvalidPassword = isValidPassword(password, passwordConfirmation);
    
    if (!_isInvalidPassword) {
      const resetModel = {
        domain: urlDomain,
        username: urlUsername,
        emailCode: token,
        password: password,
        passwordConfirmation: passwordConfirmation,
        recaptchaToken: ""
      };
      dispatch(resetPassword(resetModel)).then(() => {
        setSuccessful(true);
        setMessage(t('data-lang-msg-passwordretrieve-changed-success'));
      })
      .catch(() => {
        setLoading(false);
        setSuccessful(false);
        setMessage(t('data-lang-msg-passwordretrieve-changed-fail'));
      });
    } else {
      setLoading(false);
      setMessage("Error.");
    }
  };

  const handleShowHidePassword = (e) => {
    if (e === "pass") {
      setShowPassword(!showPassword);
    }
    if (e === "passConfirm") {
      setShowPasswordConfirm(!showPasswordConfirm);
    }
  }

  return (
      <>
        <AuthVerify currentToken={currentAuth} />
        <BackgroundSlider
          images={[img1, img2, img3]}
          duration={10} transition={2} />
        <MessageBar
          styles={{root:{marginTop: "-96px !important"}}}
          messageBarType={MessageBarType.warning} >
          <div>
            <b>{t('data-lang-msg-warning')}:</b><br/>
            <ul>
              <li>
                {t('data-lang-msg-password-policy-1')}
              </li>
              <li>
                {t('data-lang-msg-password-policy-2')}
              </li>
              <li>
                {t('data-lang-msg-password-policy-3')}
              </li>
              <li>
                {t('data-lang-msg-password-policy-4')}
              </li> 
              <li>
                {t('data-lang-msg-password-policy-5')}
              </li> 
            </ul>                
          </div>
        </MessageBar>
        <Container style={{marginTop: "300px"}} className="col-xl-5 login-bg">
          <Card className="cardforgot-container">
            <div className="profile-img-card">
                <Image
                  src={sg3}
                  alt="profile-img"
                />
            </div>
            <Form ref={form}>
              <fieldset >
                {!successful && (
                  <>
                    <Form.Group className="mb-3">
                      <Row>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="password">{t('data-lang-lbl-newpassword')}</Form.Label>
                            <div className="input-group mb-3">
                              <Form.Control
                                id="txtPassword"
                                ref={txtRefPassword}
                                name="password"
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={password}
                                onChange={onChangePassword}
                                isInvalid={isInvalidPassword !== null ? isInvalidPassword : false}
                                placeholder="" required={true} /> 
                              <span className="input-group-text" onKeyDown={() => handleShowHidePassword("pass")} onClick={() => handleShowHidePassword("pass")} role="button" tabIndex="-1">
                                {!showPassword && <AiOutlineEyeInvisible />}
                                {showPassword && <AiOutlineEye />}
                              </span>
                              {
                                isInvalidPassword === true &&
                                <div className="invalid-feedback">
                                  {passwordMessageError}
                                </div>
                              } 
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Row>
                        <Col>
                          <Form.Group className="mb-3">
                            <Form.Label htmlFor="passwordconfirmation">{t('data-lang-lbl-passwordconfirmation')}</Form.Label>
                            <div className="input-group mb-3">
                              <Form.Control
                                id="txtPasswordConfirmation"
                                ref={txtRefPasswordConfirm}
                                name="passwordConfirmation"
                                type={showPasswordConfirm ? "text" : "password"}
                                className="form-control"
                                value={passwordConfirmation}
                                onChange={onChangePasswordConfirmation}
                                isInvalid={isInvalidPasswordConfirmation !== null ? isInvalidPasswordConfirmation : false}
                                placeholder="" required={true} />
                              <span className="input-group-text" onKeyDown={() => handleShowHidePassword("passConfirm")} onClick={() => handleShowHidePassword("passConfirm")} role="button" tabIndex="0">
                                {!showPasswordConfirm && <AiOutlineEyeInvisible />}
                                {showPasswordConfirm && <AiOutlineEye />}
                              </span>
                              {
                                isInvalidPasswordConfirmation === true &&
                                <div className="invalid-feedback">
                                  {passwordConfirmationMessageError}
                                </div>
                              }
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form.Group>
                  </>
                )}
                {successful && (
                  <div className="form-group">
                    <div className={ successful ? "alert alert-success" : "alert alert-danger" } role="alert">
                      {message}
                    </div>
                  </div>
                )}
                <Form.Group className="mb-3 text-end">
                  <Row className="mb-3 text-end row justify-content-end">
                    <Button onClick={handleGoLogin} className="col-3 m-2 btn btn-primary btn-block btn btn-primary">
                      <span> {t('data-lang-btn-goback')} </span>
                    </Button>
                    {!successful && (
                      <Button onClick={handleResetPassword} className="col-5 m-2 btn btn-primary btn-block btn btn-primary" disabled={loading} >
                        {loading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                        <span> {t('data-lang-btn-resetpassword')} </span>
                      </Button>
                    )}
                  </Row>
                </Form.Group>
                {(!successful && message) && (
                  <div className="form-group">
                    <div className="alert alert-danger" role="alert">
                      {message}
                    </div>
                  </div>
                )}
                <Form.Check style={{ display: "none" }} ref={checkBtn} />
              </fieldset>
            </Form>
          </Card>
        </Container>
      </>
  );
};
    
export default ResetPassword;